interface ICardProps {
    slug: string
    imageUrl: string
    title: string
    label: string
    onClick: (slug: string) => void
}

export const Card = (props: ICardProps) => {

    const onClick = () => {
        props.onClick(props.slug)
    }

    return (
        <div className={'border-1 border-searchBorder bg-white rounded-[20px] cursor-pointer w-fit'} onClick={onClick}>
            <img className={'md:w-[200px] md:h-[200px] w-[160px] h-[160px] rounded-t-[20px] object-cover'} src={props.imageUrl} />
            <div className={'flex flex-col md:pt-4 md:px-6 md:pb-6 pt-3 px-4 pb-4 md:space-y-2 space-y-1 md:max-w-[200px] max-w-[160px]'}>
                <div className={'text-subTitle md:text-base text-sm font-sf-pro-light underline truncate'}>{props.title}</div>
                <div className={'md:text-xl text-lg truncate'}>{props.label}</div>
            </div>
        </div>
    )
}